import { apiSlice } from './apiSlice';



export interface BlockUserResponse {
  status: string;
}

export interface BlockUserPayload {
  userId: string;
  status: 'Blocked' | 'Active';
}



export const blockApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    blockUser: builder.mutation<BlockUserResponse, BlockUserPayload>({
      query: ({ userId, status }) => ({
        url: `/users/${userId}/${status}`,
        method: 'POST',
      }),
    }),
  }),
});



export const { useBlockUserMutation } = blockApi;
